// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import BlogsTable from './blogs-table';
// assets
//

// ----------------------------------------------------------------------

export default function BlogsProduct() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <BlogsTable />
        </Container >
    );
}
